/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/execution/components/ExecutionInformationPanel.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Execution Workspace
 *
 * DESCRIPTION:
 * Displays operational information required during
 * work execution.
 *
 * RESPONSIBILITIES
 * ----------------
 * ✓ Work Information
 * ✓ Execution Progress
 * ✓ Checklist Summary
 * ✓ Pending Mandatory Items
 *
 ******************************************************************************/

import React from "react";

export default function ExecutionInformationPanel({

    work,

    summary,

}) {

    return (

        <div className="row mb-4">

            {/* ====================================================== */}
            {/* WORK INFORMATION */}
            {/* ====================================================== */}

            <div className="col-lg-5 mb-3">

                <div className="card shadow-sm border-0 h-100">

                    <div className="card-header">

                        <strong>

                            Work Information

                        </strong>

                    </div>

                    <div className="card-body">

                        <table className="table table-sm mb-0">

                            <tbody>

                                <tr>

                                    <th width="35%">

                                        Priority

                                    </th>

                                    <td>

                                        {work.priority}

                                    </td>

                                </tr>

                                <tr>

                                    <th>

                                        Status

                                    </th>

                                    <td>

                                        {work.status}

                                    </td>

                                </tr>

                                <tr>

                                    <th>

                                        Due Date

                                    </th>

                                    <td>

                                        {work.due_date}

                                    </td>

                                </tr>

                                <tr>

                                    <th>

                                        Owner

                                    </th>

                                    <td>

                                        {work.owner}

                                    </td>

                                </tr>

                                <tr>

                                    <th>

                                        Executor

                                    </th>

                                    <td>

                                        {work.executor}

                                    </td>

                                </tr>

                                <tr>

                                    <th>

                                        Approver

                                    </th>

                                    <td>

                                        {work.approver}

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

            {/* ====================================================== */}
            {/* EXECUTION SUMMARY */}
            {/* ====================================================== */}

            <div className="col-lg-7 mb-3">

                <div className="card shadow-sm border-0 h-100">

                    <div className="card-header">

                        <strong>

                            Execution Progress

                        </strong>

                    </div>

                    <div className="card-body">

                        <div className="mb-3">

                            <div className="d-flex justify-content-between">

                                <span>

                                    Overall Progress

                                </span>

                                <strong>

                                    {work.progress}%

                                </strong>

                            </div>

                            <div className="progress mt-2">

                                <div
                                    className="progress-bar bg-success"
                                    style={{
                                        width:
                                            `${work.progress}%`
                                    }}
                                />

                            </div>

                        </div>

                        <div className="row text-center">

                            <div className="col-md-3 mb-3">

                                <h4>

                                    {summary.total_items}

                                </h4>

                                <small>

                                    Total Items

                                </small>

                            </div>

                            <div className="col-md-3 mb-3">

                                <h4 className="text-success">

                                    {summary.completed_items}

                                </h4>

                                <small>

                                    Completed

                                </small>

                            </div>

                            <div className="col-md-3 mb-3">

                                <h4 className="text-danger">

                                    {summary.pending_items}

                                </h4>

                                <small>

                                    Pending

                                </small>

                            </div>

                            <div className="col-md-3 mb-3">

                                <h4 className="text-warning">

                                    {
                                        summary.mandatory_items -
                                        summary.mandatory_completed
                                    }

                                </h4>

                                <small>

                                    Mandatory Pending

                                </small>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}